import React from "react";

function LanguageModal() {
  return (
    <div
      className="modal footer-lang-modal animated pulse"
      id="langModal"
      tabIndex="-1"
      aria-labelledby="langModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="far fa-xmark"></i>
          </button>

          <div className="modal-body">
            <div className="lang-content">
              <h4 className="modal-title" id="langModalLabel">
                Choose Your Language
              </h4>

              <div className="lang-list">
                <div className="row row-cols-2 row-cols-lg-3 g-2">
                  {/* Static language list */}
                  <a href="#">Arabic</a>
                  <a href="#">English</a>
                  <a href="#">Spanish</a>
                  <a href="#">German</a>
                  <a href="#">Portuguese</a>
                  <a href="#">Italian</a>
                  <a href="#">Japanese</a>
                  <a href="#">Chinese</a>
                  <a href="#">Swedish</a>
                  <a href="#">Turkish</a>
                  <a href="#">Czech</a>
                  <a href="#">Danish</a>
                  <a href="#">Greek</a>
                  <a href="#">Icelandic</a>
                  <a href="#">Irish</a>
                  <a href="#">Russian</a>
                  <a href="#">Korean</a>
                  <a href="#">Romanian</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LanguageModal;
